// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__u4C-8","controls":"styles_controls__-N_ET","charLimit":"styles_charLimit__Dsc4o","input":"styles_input__3kEY4","send":"styles_send__20yUX"};